import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import idx from 'idx';
import { getProject } from 'project/ducks/project';
import { isCollaborator } from 'project/utils';
import { getLastResourceQuery } from 'common/utils';
import { ENTRIES_RESOURCE_NAME } from 'entries/constants';
import Entry from 'single_entry/components/entry';

export function mapStateToProps(state, { params }) {
  const { single_entry } = state;
  const entry = single_entry.entriesById[params.entryId];
  const project = getProject(state);
  const userId = idx(state, _ => _.user.profile_data.id);
  const isCreative = idx(state, _ => _.user.profile_data.is_creative) || false;
  const lastEntriesQuery = getLastResourceQuery(ENTRIES_RESOURCE_NAME, state);

  return {
    ...single_entry,
    entry,
    isCreative,
    isProjectOwner: userId && userId === project.client,
    isProjectCollaborator: isCollaborator(project),
    lastEntriesQuery
  };
}

export default withRouter(connect(mapStateToProps)(Entry));



// WEBPACK FOOTER //
// ./single_entry/containers/entry.js